/**
 * Created by shubham on 10/5/18.
 */

import {ManagerListPage} from "./managerList-page";

/**
 * An array of data with an associated page object used for paging
 */
export class ManagerListPageData<T> {
    data = new Array<T>();
    page = new ManagerListPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/managerAssignment/managerList-datatable/managerList-page-data.ts